export default __webpack_public_path__ + "static/just-text-808b6bcc55b24f6ba6fe62761dcbc68f.svg";